import React from "react";
import portfolioConfig from "../config/portfolioConfig";
import SectionContainer from "./ui/SectionContainer";
import Card from "./ui/Card";
import ExternalLink from "./ui/ExternalLink";

const GitHubIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

const OpenSourceProjects = () => {
  const projects = portfolioConfig.openSourceProjects || [];

  if (projects.length === 0) return null;

  return (
    <SectionContainer id="open-source" title="Open Source">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((project, index) => (
          <Card
            key={project.id}
            hoverColor="purple-500"
            delay={index * 0.1}
            className="flex flex-col"
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">
                {project.title}
              </h3>
              <GitHubIcon className="w-6 h-6 text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white transition-colors duration-300" />
            </div>

            <p className="text-gray-500 dark:text-gray-400 text-sm mb-3 transition-colors duration-300">
              {project.period}
              {project.npmPackage && (
                <span className="ml-2 px-2 py-0.5 bg-gray-100 dark:bg-gray-800 rounded text-xs font-mono text-gray-600 dark:text-gray-300 transition-colors duration-300">
                  {project.npmPackage}
                </span>
              )}
            </p>

            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4 flex-1 transition-colors duration-300">
              {project.description}
            </p>

            <div className="flex flex-wrap gap-2 mb-4">
              {project.technologies.map((tech, techIndex) => (
                <span
                  key={techIndex}
                  className="px-3 py-1 bg-blue-50 dark:bg-blue-900 dark:bg-opacity-30 border border-blue-200 dark:border-blue-500 rounded-full text-blue-700 dark:text-blue-300 text-xs font-medium transition-colors duration-300"
                >
                  {tech}
                </span>
              ))}
            </div>

            <div className="flex items-center gap-4 mt-auto pt-2 border-t border-gray-100 dark:border-gray-800 transition-colors duration-300">
              <ExternalLink href={project.githubUrl} color="blue">
                <GitHubIcon className="w-4 h-4 mr-1.5" />
                GitHub
              </ExternalLink>
              {project.liveUrl && (
                <ExternalLink href={project.liveUrl} color="purple">
                  Website
                </ExternalLink>
              )}
            </div>
          </Card>
        ))}
      </div>
    </SectionContainer>
  );
};

export default OpenSourceProjects;
